import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { SERVICE_FEES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import Icon, { IconIds } from 'src/common/components/IconDS22';
import styles from './ToolList.module.scss';

type ListItem = { id: number; icon: IconIds; points: number[] };

const list: ListItem[] = [
  { id: 0, icon: 'globe', points: [0, 1, 2, 3] },
  { id: 1, icon: 'calendar-range', points: [0, 1, 2, 3] },
  { id: 2, icon: 'credit-card', points: [0, 1, 2, 3] },
];

const ToolList: FC = () => {
  const [t] = useTranslation('for-owners-page');

  return (
    <PitchPageLayout backgroundColor="pearl">
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.title}>
            <Typography
              type="h2"
              size="display-5"
              sizeFromBreakpointM="display-4"
            >
              {t('tool-list--title')}
            </Typography>
          </div>
          <Typography type="p" size="body-xl">
            {t('tool-list--text')}
          </Typography>
        </div>
        <ul className={styles.toolList}>
          {list.map((item) => (
            <li className={styles.toolListItem} key={item.id}>
              <Icon id={item.icon} size="xl" className={styles.icon} />
              <div className={styles.title}>
                <Typography
                  type="h3"
                  size="heading-5"
                  weight="semibold"
                >
                  {t(`tool-list--item-${item.id}--title`)}
                </Typography>
              </div>
              <Typography
                type="p"
                size="body-xl"
              >
                {t(`tool-list--item-${item.id}--text`)}
              </Typography>
              <ul className={styles.pointList}>
                {item.points.map((pointId) => (
                  <li key={`${item.id}--point--${pointId}`}>
                    <Typography
                      type="p"
                      size="body-l"
                    >
                      {t(`tool-list--item-${item.id}--point-${pointId}`, { transactionFee: SERVICE_FEES.TRANSACTION_FEE })}
                    </Typography>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </PitchPageLayout>
  );
};

export default ToolList;
